"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blessDefinition = blessDefinition;

var _blessing = require("./blessing");

/** @hidden */
function blessDefinition(definition) {
  return {
    identifier: definition.identifier,
    controllerConstructor: (0, _blessing.bless)(definition.controllerConstructor)
  };
}